import React from "react";
import * as styled from "./styled";

interface InputProps {
  id: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputProps?: object;
  type?: "text" | "number" | "password";
  max?: number;
  min?: number;
  maxlength?: number;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  inline?: boolean;
}

const Input = (props: InputProps) => {
  const {
    id,
    inputProps,
    type,
    max,
    min,
    maxlength,
    placeholder,
    disabled,
    error,
    inline,
    value,
    onChange,
  } = props;
  return (
    <styled.InputWrapper className="input-wrapper">
      <styled.Input
        {...inputProps}
        max={max}
        maxLength={maxlength}
        min={min}
        id={id}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
        inline={inline}
        value={value}
        onChange={onChange}
      />
      <styled.ErrorWrapper>
        {error && <span className="custom-error">{error}</span>}
      </styled.ErrorWrapper>
    </styled.InputWrapper>
  );
};

export default Input;
